import { render } from "./InstitutionPlansList.vue?vue&type=template&id=6a52e576&scoped=true"
import script from "./InstitutionPlansList.vue?vue&type=script&lang=js"
export * from "./InstitutionPlansList.vue?vue&type=script&lang=js"

import "./InstitutionPlansList.vue?vue&type=style&index=0&id=6a52e576&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a52e576"]])

export default __exports__